import { render, staticRenderFns } from "./DocumentUpload.vue?vue&type=template&id=cb3240c2&scoped=true"
import script from "./DocumentUpload.vue?vue&type=script&lang=js"
export * from "./DocumentUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb3240c2",
  null
  
)

export default component.exports